"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var PromoApplicationStatus_1 = require("../model/PromoApplicationStatus");

var ApplicationStatusConverter_1 = require("./ApplicationStatusConverter");

var PromoApplicationStatusConverterImpl =
/*#__PURE__*/
function (_ApplicationStatusCon) {
  _inherits(PromoApplicationStatusConverterImpl, _ApplicationStatusCon);

  function PromoApplicationStatusConverterImpl() {
    _classCallCheck(this, PromoApplicationStatusConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromoApplicationStatusConverterImpl).apply(this, arguments));
  }

  _createClass(PromoApplicationStatusConverterImpl, [{
    key: "toDocument",

    /** @inheritDoc */
    value: function toDocument(source, conversions) {
      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var result = {};
      Object.assign(result, conversions.classToDocumentId(source));
      Object.assign(result, {
        frontendLocked: source.frontendLocked
      });
      return result;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toObject",
    value: function toObject(source, conversions) {
      return new PromoApplicationStatus_1.PromoApplicationStatus(PromoApplicationStatus_1.PromoApplicationStatus.schema.id.valueOf(conversions.documentToClassId(source)), PromoApplicationStatus_1.PromoApplicationStatus.schema.frontendLocked.valueOfField(source));
    }
  }]);

  return PromoApplicationStatusConverterImpl;
}(ApplicationStatusConverter_1.ApplicationStatusConverter);

exports.PromoApplicationStatusConverterImpl = PromoApplicationStatusConverterImpl;